<template>
  <el-card v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item>Avisos</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <div class="loading" v-loading="loading" v-if="fecthItems.length === 0"></div>
    <template v-else>
      <app-modal-draggable
        v-if="modalDraggable"
        :content="tableQuery"
        :name="'title'"
        :table="'desktop'"
      ></app-modal-draggable>
      <app-table-paginate
        :routeEdit="routeEdit"
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :preview="preview"
        :limit="limit"
        :draggable="false"
        :search="true"
        :selection="'no'"
        :customBtn="tableCustomBtn"
      ></app-table-paginate>
      <br />
      <br />
      <br />
      <el-button type="primary" size="medium" @click="nuevoRegistro()">
        Nuevo
        <i class="el-icon-circle-plus-outline el-icon-right"></i>
      </el-button>
    </template>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";
import moment from "moment-timezone";

export default {
  name: "NotificacionesList",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable,
  },
  async created() {
    this.routeEdit = "/dashboard/" + this.$route.params.db + "/plugins/avisos/edit/";
    this.init();
    this.$root.$on("delete", (id) => {
      this.eliminarRegistro(id);
    });
    this.$root.$on("customBtn", (id) => {
      this.$router.push(
        "/dashboard/" + this.$route.params.db + "/plugins/avisos/envios/" + id.id
      );
    });
  },

  data() {
    return {
      tableColumns: [
        {
          prop: "nombre",
          label: "Nombre",
        },

        {
          prop: "per",
          label: "Periodo",
        },

        {
          prop: "envios",
          label: "Items",
        },
      ],
      tableCustomBtn: { icon: "fa  fa-calendar", nombre: "Ver Items" },
      tableQuery: {},
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      preview: null,
      templates: false,
      modalDraggable: false,
      limit: 10,
      access: [],
      loading: true,
    };
  },
  watch: {
    $route(to) {
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/plugins/avisos/" +
        this.$route.params.table +
        "/";
      this.init();
    },
  },
  methods: {
    async init() {
      await this.getPages();
    },
    nuevoRegistro() {
      this.$router.push("/dashboard/" + this.$route.params.db + "/plugins/avisos/new");
    },

    async getPages() {
      this.tableQuery = [];
      const a = await ApiService.post("dashboard/plugin/avisos/get", {
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (a.data != "Algo ha fallado") {
        a.data.forEach((element) => {
          this.tableQuery.push(element);
        });
      } else {
        this.tableQuery = {};
      }

      this.loading = false;
    },
    async eliminarRegistro(id) {
      const response = await ApiService.post("dashboard/editform", {
        table: "plugin_avisos_list",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: { flag_borrado: 1 },
        id: id,
      });
      this.getPages();
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.init();
    },
  },
  computed: {
    fecthItems() {
      return this.tableQuery;
    },
    ...mapGetters(["userAccessPlugins"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/plugins/avisos/list.vue